import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../utils/axios";

const initialState = {
  loading: false,
  activeRewardsData: [],
  error: "",
  success: false,
  status: "",
};

const fetchActiveRewards = createAsyncThunk(
  "fetch/active-rewards",
  async ({ status }) => {

    const mobile = localStorage.getItem("mobile");
    try {
      const result = await axios.get(
        `https://apac.api.capillarytech.com/mobile/v2/api/get/marvel/vouchers?mobile=${mobile}&cap_brand=${process.env.REACT_APP_BRAND}&status=${status}&till_id=${process.env.REACT_APP_TILL_ID}`
      );
      return result?.data;
    } catch (err) {
      console.log(err);
    }
  }
);

const activeRewardsSlice = createSlice({
  name: "active-rewards",
  initialState,
  reducers: {
    resetData: (state, payload) => {
      state.loading = false;
      state.success = false;
      state.error = "";
      state.activeRewardsData = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchActiveRewards.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchActiveRewards.fulfilled, (state, action) => {
      // console.log(action.payload, "action payload active rewards");
      state.loading = false;
      state.activeRewardsData = action?.payload?.userVouchers;
      state.success = action?.payload?.status?.success;
      state.error = "";
    });
    builder.addCase(fetchActiveRewards.rejected, (state, action) => {
      state.loading = false;
      state.activeRewardsData = [];
      state.error = action.error.message;
    });
  },
});

export default activeRewardsSlice.reducer;
export const { resetData } = activeRewardsSlice.actions;
export { fetchActiveRewards };
